"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.removeInternalProperties = void 0;
var glossary_1 = require("../glossary");
var isInternalEntity_1 = require("./isInternalEntity");
/**
 * Removes internal properties from the given entity.
 */
function removeInternalProperties(entity) {
    return (Object.entries(entity)
        // Remove internal entity properties.
        .filter(function (_a) {
        var _b = __read(_a, 2), property = _b[0], value = _b[1];
        if (property !== glossary_1.InternalEntityProperty.type &&
            property !== glossary_1.InternalEntityProperty.primaryKey) {
            return [property, value];
        }
    })
        .map(function (_a) {
        var _b = __read(_a, 2), property = _b[0], value = _b[1];
        // Remove internal properties of a "oneOf" relation.
        if (typeof value === 'object' && isInternalEntity_1.isInternalEntity(value)) {
            return [property, removeInternalProperties(value)];
        }
        // Remove internal properties of a "manyOf" relation.
        if (Array.isArray(value)) {
            var publicEntity = value.map(function (relationalEntity) {
                return isInternalEntity_1.isInternalEntity(relationalEntity)
                    ? removeInternalProperties(relationalEntity)
                    : relationalEntity;
            });
            return [property, publicEntity];
        }
        return [property, value];
    })
        .reduce(function (entity, _a) {
        var _b = __read(_a, 2), property = _b[0], value = _b[1];
        entity[property] = value;
        return entity;
    }, {}));
}
exports.removeInternalProperties = removeInternalProperties;
